import unsavedChangesModalEn from "./locales/en.json";

export const UNSAVED_CHANGES_MODAL_NS = "unsavedChangesModal" as const;

export const UnsavedChangesModalTranslations = {
  en: {
    [UNSAVED_CHANGES_MODAL_NS]: {
      ...unsavedChangesModalEn,
    },
  },
};
